import { loginFormTranslationsPl } from '../../app/pages/authorization/LoginForm/translations';
import { usersPageTranslationsPl } from '../../app/pages/users/translations';
import { notFoundPageTranslationsPl } from '../../app/pages/notFoundPage/translations';
import { commonTranslationsPl } from './common/translations';
import { versionsPageTranslationsPl } from '../../app/pages/versions/translations';
import { tachoModalTranslationsPl } from '../../app/components/TachoModal/translations';
import { confirmationModalTranslationsPl } from '../../app/components/TachoConfirmationModal/translations';
import { licencesPageTranslationsPl } from '../../app/pages/licenses/translations';
import { tachoReleaseTypeEnumTranslationsPl } from '../domainModels/versions/TachoReleaseType';
import { clientsPageTranslationsPl } from '../../app/pages/clients/translations';
import { distributorsPageTranslationsPl } from '../../app/pages/distributors/translations';
import { licenseTermsPageTranslationsPl } from '../../app/pages/licenseTerms/translations';

export const polish = {
    Key: 'pl-PL',
    values: {
        ...notFoundPageTranslationsPl,
        ...commonTranslationsPl,
        ...loginFormTranslationsPl,
        ...usersPageTranslationsPl,
        ...versionsPageTranslationsPl,
        ...tachoModalTranslationsPl,
        ...confirmationModalTranslationsPl,
        ...licencesPageTranslationsPl,
        ...tachoReleaseTypeEnumTranslationsPl,
        ...clientsPageTranslationsPl,
        ...distributorsPageTranslationsPl,
        ...licenseTermsPageTranslationsPl,
    },
};
